import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Spinner } from '@celltrak/ui-components';

import { text } from '../../constants';

import ProfileFormFields from './ProfileFormFields';
import styles from './ProfileInfoForm.module.scss';

const ProfileInfoForm = ({ isLoading, values, handleAgencyNameChange, handleToggleChange }) => {
  const renderSpinner = () => (
    <div className={styles.spinner}>
      <Spinner color="primary">{text.saving}</Spinner>
    </div>
  );

  const renderForm = () => (
    <ProfileFormFields
      values={values}
      handleAgencyNameChange={handleAgencyNameChange}
      handleToggleChange={handleToggleChange}
    />
  );

  return isLoading ? renderSpinner() : renderForm();
};

ProfileInfoForm.propTypes = {
  isLoading: PropTypes.bool,
  handleToggleChange: PropTypes.func,
  handleAgencyNameChange: PropTypes.func,
  values: PropTypes.shape({
    active: PropTypes.bool,
    agencyName: PropTypes.string,
  }),
};

ProfileInfoForm.defaultProps = {
  isLoading: false,
  handleToggleChange: noop,
  handleAgencyNameChange: noop,
  values: {},
};

export default ProfileInfoForm;
